import {handleActions} from "redux-actions";
import {constants as Constants } from "./index";

export const initialState = {
    isRunning: false,
    name: '',
    remainingTime: 0,
    timestamp: 0
};

export default handleActions({
    [Constants.TIMER_TICK]: (state: any, data: any) => ({
        isRunning: true,
        name: data.payload.name,
        remainingTime: data.payload.remainingTime,
        team: data.payload.team,
        timestamp: data.payload.timestamp
    }),
    [Constants.TIMER_STOP]: (state: any) => (initialState)
}, initialState);



// WEBPACK FOOTER //
// ./src/redux/modules/timer/reducer.ts